import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-notify-warning-custom',
  templateUrl: './notify-warning-custom.component.html',
  styleUrls: ['./notify-warning-custom.component.scss']
})
export class NotifyWarningCustomComponent implements OnInit {
  highligth = false;
  constructor(
    public dialogRef: MatDialogRef<NotifyWarningCustomComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DataDiaLog,
  ) {
    // them chuc nang close message băng Esc va click chuot
    dialogRef.disableClose = false;
    if ( data && data.highligth ) {
      this.highligth = data.highligth;
    }
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }
}

interface DataDiaLog {
  title?: string;
  content?: string;
  textBtn?: string;
  highligth: boolean;
}
